import React, { FC } from "react";

export interface SaleOffBadgeProps {
  className?: string;
  status?: string;
  // bgColor?: string;
}

const SaleOffBadge: FC<SaleOffBadgeProps> = ({
  className = "",
  status = "",
  // bgColor = "",
}) => {
 
  var bgColor = "";
  if (status === "waiting"){
    status = "waiting approval"
    bgColor = "bg-orange-500"
  }else if (status === "approved"){
    status = "Approved"
    bgColor = "bg-[#19CFD8]"
  }

  return (
    <div
      // className={`nc-SaleOffBadge flex items-center justify-center text-xs py-2 px-3 bg-[#E56107] text-red-50  ${className}`}
      className={`nc-SaleOffBadge flex items-center justify-center text-xs py-2 px-3 rounded-bl-lg text-white ${className} ${bgColor}`}

      data-nc-id="SaleOffBadge"
    >
      {status}
    </div>
  );
};

export default SaleOffBadge;
